import type React from 'react';

import { TableCell as BaseTableCell, type TableCellProps as BaseTableCellProps } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as styles from './styles';

import { applyCustomStyles } from '../../styles';

export enum CellType {
  DEFAULT = 0,
  DESCRIPTION = 1,
  BLACK_DESCRIPTION = 2,
}

const cellStyles = {
  [CellType.DEFAULT]: styles.defaultCell,
  [CellType.DESCRIPTION]: styles.descriptionCell,
  [CellType.BLACK_DESCRIPTION]: styles.blackDescriptionCell,
};

const DefaultTableCell = withStyles({
  root: {
    border: 'none',
    padding: '0 10px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    letterSpacing: 'normal',

    '&:first-child': {
      paddingLeft: 20,
    },

    '&:last-child': {
      paddingRight: 20,
    },
  },
})(BaseTableCell);

const StyledTableCell = applyCustomStyles(DefaultTableCell);

interface TableCellProps extends BaseTableCellProps {
  type?: CellType;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const TableCell: React.FC<TableCellProps> = ({ type = CellType.DEFAULT, children, ...otherProps }) => (
  <StyledTableCell customStyles={cellStyles[type]} {...otherProps}>
    {children}
  </StyledTableCell>
);
